export default __webpack_public_path__ + "static/media/img_linux-colorBkg.2a220106.png";